import { render } from "./Mind.vue?vue&type=template&id=5acf1364&scoped=true"
import script from "./Mind.vue?vue&type=script&lang=js"
export * from "./Mind.vue?vue&type=script&lang=js"

import "./Mind.vue?vue&type=style&index=0&id=5acf1364&lang=scss&scoped=true"

import exportComponent from "/apps/srv/jenkins/workspace/feihua_fe_mguoxueweb_online/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5acf1364"]])

export default __exports__